import {
  Alert,
  AlertIcon,
  Button,
  Container,
  Heading,
  HStack,
  Spinner,
  Stack,
  Text,
} from "@chakra-ui/react"

type Props = {
  title: string
  onCancel: () => void
  isBusy: boolean
  canCreate: boolean
  busyLabel: string
  idleLabel: string
  unavailableLabel?: string
}

export default function DocumentDraftBootstrapPage({
  title,
  onCancel,
  isBusy,
  canCreate,
  busyLabel,
  idleLabel,
  unavailableLabel = "Brak aktywnego magazynu bez blokady inwentaryzacyjnej.",
}: Props) {
  return (
    <Container maxW="4xl" py={6}>
      <Stack spacing={6}>
        <HStack justify="space-between" align="center">
          <Heading size="lg">{title}</Heading>
          <Button variant="ghost" onClick={onCancel}>
            Anuluj
          </Button>
        </HStack>
        {isBusy ? (
          <HStack borderWidth="1px" borderRadius="xl" p={6} spacing={4}>
            <Spinner color="green.500" />
            <Text>{busyLabel}</Text>
          </HStack>
        ) : !canCreate ? (
          <Alert status="warning" borderRadius="xl">
            <AlertIcon />
            {unavailableLabel}
          </Alert>
        ) : (
          <Alert status="info" borderRadius="xl">
            <AlertIcon />
            {idleLabel}
          </Alert>
        )}
      </Stack>
    </Container>
  )
}
